export const areAllValuesDefined = (...values: (number | null | undefined)[]) =>
  values.every((value) => value !== undefined && value !== null);
